<template>
  <companyContent/>
</template>

<script>
import companyContent from '@/components/_manageroleapprover/overview.vue'
export default {
  components: {
    companyContent
  }
}
</script>
